import React from 'react';

import { Grid } from '@material-ui/core';

import { KaaPTenantAboutCard } from './KaaPTenantAboutCard';
import { KaaPTenantRelationsCard } from './KaaPTenantRelationsCard';

interface KaaPTenantOverviewContentCardProps {
  ActionContent: React.JSX.Element;
  EntityWarningContent: React.JSX.Element;
}

export const KaaPTenantOverviewContentCard = ({
  ActionContent,
  EntityWarningContent,
}: KaaPTenantOverviewContentCardProps) => {
  return (
    <Grid container spacing={3} alignItems="stretch">
      {EntityWarningContent}
      {ActionContent}

      <Grid item md={6} xs={12}>
        <KaaPTenantAboutCard variant="fullHeight" />
      </Grid>

      <Grid item md={6} xs={12}>
        <KaaPTenantRelationsCard />
      </Grid>
    </Grid>
  );
};
